import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import EditPerson from "./EditPerson";
import PersonDetail from "./PersonDetail";
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      routeStatus: 0
    };
  }
  changeRouteStatus = value => {
    this.setState(prevState => {
      return {
        routeStatus: value
      };
    });
  };
  render() {
    const { routeStatus } = this.state;
    return (
      <React.Fragment>
        <div className="wrapper position-relative">
          {routeStatus == 0 && (
            <PersonDetail changeRouteStatus={this.changeRouteStatus} />
          )}
          {routeStatus == 1 && (
            <EditPerson changeRouteStatus={this.changeRouteStatus} />
          )}
        </div>
      </React.Fragment>
    );
  }
}
export default withRouter(Index);
